import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removeUser } from '../../redux/actions/users';

interface Props {
  match: any;
  handleRemoveUser: Function;
}

const Route = ({ match, handleRemoveUser }: Props) => (
  <RouteWrapper
    title="Remove User"
    requireAuth
    requirePermission="MANAGE_USERS"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove User?</Title>
      <Subtitle>
        Once this user is removed, they will not be able to access the account
        anymore.
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemoveUser(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove User
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/settings/users/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemoveUser: (id) => {
    dispatch(removeUser(id)).then((response) => {
      if (!response.error) {
        dispatch(goBack());
        dispatch(goBack());
      } else {
        dispatch(goBack());
      }
    });
  },
});

export default connect(() => ({}), mapDispatchToProps)(Route);
